/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TimelineHistory from '../../../../../../../components/ui-elements/timeline/TimelineHistory';
import { Typography } from '@mui/material';
import { useState } from 'react';
import { getOrgUserHistory } from '../../../../../../../store/reducers/organization/orgUsers/orgUsersAction';

const OrgUserHistory = ({ selectedOrgUser }) => {
    const [historyList, setHistoryList] = useState([]);
    const dispatch = useDispatch();
    const orgUserHistory = useSelector(state => state.orgUsers.orgUserHistory)
    useEffect(() => {
        dispatch(getOrgUserHistory({ "organizationUserID": selectedOrgUser.organizationUserID }))

    }, [dispatch, selectedOrgUser]);
    useEffect(() => {
        setHistoryList([]);
        if (orgUserHistory?.length > 0) {
            orgUserHistory.forEach(element => {
                setHistoryList(item => [...item, {
                    ...element, Record: {
                        name: element.Record.organizationUserName,
                        details: element.Record.organizationUserDetails,
                        createdBy: element.Record.createdBy ?? "",
                        updatedBy: element.Record.updatedBy ?? "",
                    }
                }]);
            });
        }
    }, [orgUserHistory]);
    return (
        <>
            <Typography variant="h3" align="center" color="success.light">Organization User History</Typography>
            <TimelineHistory items={historyList} />
        </>
    )

}


export default OrgUserHistory;